import { rokidAgentStoreBaseUrl,rokidBaseUrl,rokidRcsUrl } from "@rokid/host";
import { request, type IRequest} from '@rokid/utils';
import type {
  IPostAgentPublishReq,
  IPostAgentPublishRes,
  IPostPromptTryReq,
  IPostPromptTryRes,
  checkContentSignReq,
  checkContentSignRes,
  checkContentBatchReq,
  checkContentBatchRes
} from './publish.d';


/**
 * agent 提审
 */
export const agentPublish: IRequest<IPostAgentPublishReq, IPostAgentPublishRes> = (
  data
) => {
  return request({
    url: `${rokidAgentStoreBaseUrl}/developer/cozePublish`,
    method: 'post',
    data,
  }).then((res) => res);
};

/**
 * 提示词命中检测
*/
export const agentPromptTry = (data:IPostPromptTryReq) => {
  return request<IPostPromptTryReq, IPostPromptTryRes>({
    url: `${rokidBaseUrl}/api/prompt/try_match`,
    method: 'post',
    data,
  }).then((res) => res);
};



/*获取agent的分类列表*/
export const getAgentTypelist = () => {
  return request({
    url: `${rokidRcsUrl}/systemParam/getParam`,
    method: 'post',
    data: {"code":"cozeAgentTypeList"}
  }).then((res) => { 
    if (res.code === 1) {
      return JSON.parse(res.data.paramValue);
    } else { 
      return [];
    }
  });
};

/*获取AIUI智能体的白名单用户*/
export const getLocalAgentUsers = () => {
  return request({
    url: `${rokidRcsUrl}/systemParam/getParam`,
    method: 'post',
    data: {"code":"cozeAgentLocalAgentUsers"}
  }).then((res) => {
    if (res.code === 1) {
      return JSON.parse(res.data.paramValue);
    } else { 
      return [];
    }
  });
};

/*获取模型思考深度开关*/
export const getModelThinkingSWitch = () => {
  return request({
    url: `${rokidRcsUrl}/systemParam/getParam`,
    method: 'post',
    data: {"code":"cozeAgentModelThinking"}
  }).then(({code,data}) => {
    if (code === 1 && Number(data.paramValue) === 1) {
      return true;
    } else { 
      return false;
    }
  });
};


//内容检测-单个
export const checkContentSign: IRequest<checkContentSignReq,checkContentSignRes> =
  (data:checkContentSignReq) => {
    return request({
      url: `${rokidAgentStoreBaseUrl}/moderation/singleCheck`,
      method: 'post',
      data,
    }).then((res) => {
      if (res.code === 1) {
        // 直接返回目标类型
        return res.data;
      }
      // 你也可以 reject，以保持类型统一
      return Promise.reject(new Error(res.msg || 'checkContentSign failed'));
    });
  };
//内容检测-批量
export const checkContentBatch: IRequest<checkContentBatchReq[], checkContentBatchRes[]> =
  (data:checkContentBatchReq[]) => {
    return request({
      url: `${rokidAgentStoreBaseUrl}/moderation/batchCheck`,
      method: 'post',
      data,
    }).then((res) => {
      if (res.code === 1) {
        return res.data;
      }
      return Promise.reject(new Error(res.msg || 'checkContentBatch failed'));
    });
  };

